// extracted by mini-css-extract-plugin
module.exports = {"container":"Badge_container__GXfIf","content":"Badge_content__Ue8Y7","bottomRight":"Badge_bottomRight__XbkHH","topLeft":"Badge_topLeft__sa186"};